import { useState, useEffect } from "react";

const Ping = ({ className }) => {
  const [playAnimation, setPlayAnimation] = useState(false);

  useEffect(() => {
    const startAnimationTimeout = setTimeout(() => {
      setPlayAnimation(true);

      const stopAnimationTimeout = setTimeout(() => {
        setPlayAnimation(false);
      }, 10000); // 10000 milliseconds = 10 seconds

      return () => {
        clearTimeout(stopAnimationTimeout); // Clear the stop animation timeout if the component unmounts before it's triggered
      };
    }, 5000); // 5000 milliseconds = 5 seconds

    return () => {
      clearTimeout(startAnimationTimeout); // Clear the start animation timeout if the component unmounts before it's triggered
    };
  }, []);
  return (
    <div className={playAnimation ? className : "hidden"}>
      <span className={"relative  h-5 w-5"}>
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#fd7e14] opacity-75"></span>
        <span className="relative inline-flex rounded-full h-5 w-5 bg-nivabupa-ethinosHomeOrange"></span>
      </span>
    </div>
  );
};

export default Ping;
